import React, { useState, useEffect } from 'react';
import { useTranslations } from '../translations/translations';

const MissionsCarousel = () => {
  const t = useTranslations();
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    {
      url: '/assets/l5akjayi_WhatsApp-Image-2024-07-12-at-10.38.50.jpeg',
      alt: 'Mission Aéroport Paris Le Bourget'
    },
    {
      url: '/assets/e220tjfa_WhatsApp-Image-2024-06-24-at-12.36.57.jpeg',
      alt: 'Transport Sécurisé VIP'
    },
    {
      url: '/assets/q1yipa5n_WhatsApp-Image-2024-06-07-at-11.10.43.jpeg',
      alt: 'Mission Officielle Palais'
    },
    {
      url: '/assets/67cqvc8y_f43f6b8d-1fbb-41f0-b379-1d31567d31f8.jpg',
      alt: 'Protection Présidentielle'
    },
    {
      url: '/assets/r269zgp1_WhatsApp-Image-2026-04-07-at-18.27.36-1-.jpegvt.jpeg',
      alt: 'Mission Internationale'
    },
    {
      url: '/assets/wwl9h62r_WhatsApp-Image-2026-04-07-at-18.27.36-2-.jpegvt.jpeg',
      alt: 'Escorte Sécurisée Nocturne'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div style={{
      marginTop: '6rem',
      padding: '4rem 0',
      borderTop: '1px solid #262626'
    }}>
      <h3 style={{
        fontSize: '1.5rem',
        fontWeight: 300,
        letterSpacing: '-0.01em',
        textAlign: 'center',
        marginBottom: '3rem',
        color: '#ffffff'
      }}>
        {t.missions.title}
      </h3>

      <div style={{
        position: 'relative',
        height: '280px',
        overflow: 'hidden',
        borderRadius: '4px'
      }}>
        {images.map((image, index) => (
          <div
            key={index}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              opacity: index === currentIndex ? 1 : 0,
              transition: 'opacity 1s ease-in-out',
              filter: 'grayscale(100%)'
            }}
          >
            <img
              src={image.url}
              alt={image.alt}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center'
              }}
            />
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.4)'
            }} />
          </div>
        ))}
      </div>

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '0.5rem',
        marginTop: '2rem'
      }}>
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              background: index === currentIndex ? '#ffffff' : '#404040',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            aria-label={`Image ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default MissionsCarousel;
